import { TLoadout } from "MVVM/Views/CreateMontage/@types";
import { atom } from "recoil";
import { persistAtom } from ".";

export const QuickEditTitle = atom<string>({
  key: "QuickEditTitle",
  default: "",
});

export const QuickEditPreferredLoadout = atom<TLoadout | null>({
  key: "QuickEditPreferredLoadout",
  default: null,
  effects_UNSTABLE: [persistAtom],
});

export const QuickEditPreferredFinalTouches = atom<string[]>({
  key: "QuickEditPreferredFinalTouches",
  default: [],
  effects_UNSTABLE: [persistAtom],
});

export const QuickEditPreferredThumbnail = atom<string>({
  key: "QuickEditPreferredThumbnail",
  default: "",
  effects_UNSTABLE: [persistAtom],
});
